import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {LoadingText} from 'shells/loading-placeholder/loading-text';
import {Body} from 'shells/typography/body';

import styles from './transcription-section.module.css';

type Props = {
    callHasEnded: boolean;
    shouldTranscribe: boolean;
    transcription?: string | null | undefined;
};

export function TranscriptionSection(props: Props) {
    if (!props.shouldTranscribe) {
        return (
            <StackLegacy spacing={4}>
                <Body size='small' isBold={true}>
                    Transcript
                </Body>
                <div className='border br-3 px-16 py-8'>
                    <Body size='small'>This call is not being transcribed</Body>
                </div>
            </StackLegacy>
        );
    }

    return (
        <StackLegacy spacing={4}>
            <Body size='small' isBold={true}>
                Transcript
            </Body>
            <div className={styles['section-wrapper']}>
                {props.callHasEnded && props.transcription ? (
                    <Body size='small'>{props.transcription}</Body>
                ) : (
                    <>
                        <Body size='small'>
                            {props.callHasEnded
                                ? 'Your transcript is loading…'
                                : 'Your transcript will load here after this conversation ends.'}
                        </Body>
                        <LoadingText width={480} />
                        <LoadingText width={480} />
                    </>
                )}
            </div>
        </StackLegacy>
    );
}
